<template>
  <v-app style="background-color: #f3f6f9">
    <v-main>
      <nav-bar></nav-bar>
      <LogsComp />
    </v-main>
  </v-app>
</template>
<script>
import NavBar from '@/components/widgets/navBar.vue'
import LogsComp from '@/components/admin/logsPage/LogsComp.vue'
import Auth from '@/services/auth.service.js'


export default {
  components: {
    NavBar,
    LogsComp
  },
  mounted() {
    document.title = 'Logs | ISRASIM'

    let auth = Auth.checkAuth();
    if (!auth) {
      this.$router.replace({ name: "login" })
    }
  },
}
</script>
  